/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import e from"../FenceGeotrigger.js";import r from"../Geotrigger.js";const o={base:r,key:"type",typeMap:{fence:e}};export{o as types};
